import { createI18n } from 'vue-i18n'
import fr from '@/locales/fr.json'

const messages = {
  fr,
}

const i18n = createI18n({
  legacy: false, // Vue 3 Composition API mode
  locale: import.meta.env.VUE_APP_I18N_LOCALE || process.env.VUE_APP_I18N_LOCALE || 'fr',
  fallbackLocale: import.meta.env.VUE_APP_I18N_FALLBACK_LOCALE || process.env.VUE_APP_I18N_FALLBACK_LOCALE || 'fr',
  messages,
  globalInjection: true,
})

export default i18n
